import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';

// Components
import {Icon, Modal} from '@drivesally/sally-ui';
import Wrapper from './components/Wrapper';
import Thumbnail from './components/Thumbnail';
import Overlay from './components/Overlay';
import Caption from './components/Caption';
import FullImage from './components/FullImage';

// A small clickable thumbnail that opens the full-size image in its own
// Modal - the same Modal component used everywhere else in this app
// (GasModal included), just with a plain image as its content.
class ExpandableThumbnail extends Component {
  static propTypes = {
    src: PropTypes.string,
    label: PropTypes.node,
  };

  state = {
    expanded: false,
  };

  expand = () => this.setState({expanded: true});
  collapse = () => this.setState({expanded: false});

  render() {
    const {src, label} = this.props;
    const {expanded} = this.state;
    if (!src) return null;

    return (
      <Fragment>
        <div>
          <Wrapper onClick={this.expand}>
            <Thumbnail src={src} />
            <Overlay data-overlay>
              <Icon icon="search" />
            </Overlay>
          </Wrapper>
          {!!label && <Caption>{label}</Caption>}
        </div>
        <Modal
          visible={expanded}
          onClose={this.collapse}
          size="large"
          title={label || 'Image'}
        >
          {(Content) => (
            <Content padding="none">
              <FullImage src={src} />
            </Content>
          )}
        </Modal>
      </Fragment>
    );
  }
}

export default ExpandableThumbnail;
